module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110263-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110263-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("The Events of the Journal")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-5"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1825  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("WORKS IN HAND")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Reminiscences of Ireland, and of Moore and Byron – Visit of Mrs. Coutts – Lockhart’s appointment as editor of the "), _c('i', [_vm._v("Quarterly")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol.i. "), _c('i', [_vm._v("Woodstock")]), _vm._v(", vol.i.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visits from R. P. Gillies – Departure of Lockhart and Sophia for London – Fears of Constable’s failure – Christmas at Abbotsford – Attack of gallstones.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. ii. ‘"), _c('i', [_vm._v("Bonnie Dundee")]), _vm._v("’. Introduction to "), _c('i', [_vm._v("Memoirs of Mme La Rochejacquelin")]), _vm._v(". Review of Pepys for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". Notes on Sheridan for Lockhart. \n                        ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00002"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-44"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1826 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Skenes, Knight, Mathews, and Scrope at Abbotsford – Scott returns to Edinburgh on the 16th and finds he is ruined – The creditors agree to a Trust.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Woodstock")]), _vm._v(", vols i and ii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Cadell flees to the Sanctuary – Scott refuses to consider a seat on the Bench – New Exhibition Room opened – 39 Castle Street put up for sale – Scott attacks the Government in the first two "), _c('i', [_vm._v("Letters of Malachi")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Woodstock:")]), _vm._v(" vol. ii finished 11 February; vol. iii. "), _c('br'), _vm._v("             First and second "), _c('i', [_vm._v("Letters of Malachi Malagrowther")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Meetings of protest – A third "), _c('i', [_vm._v("Letter of Malachi – ")]), _vm._v("Quarrel with Lord Melville – Feelings of depression – Scott removes to Abbotsford on the 15th – Illness of Lady Scott – Letters from Croker, who has attacked"), _c('i', [_vm._v(" Malachi")]), _vm._v(" – First news of the money in Chancery belonging to Lady Scott.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Malachi Malagrowther")]), _vm._v(", Letter III. "), _c('br'), _vm._v("             Notes for "), _c('i', [_vm._v("Napoleon")]), _vm._v(". "), _c('i', [_vm._v("Woodstock:")]), _vm._v(" finished 26 March.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Woodstock")]), _vm._v(" sold for £8228 – Henry Scott of Harden to stand for Parliament – Lady Scott’s illness continues – Birth of Scott’s grandson, Walter, in Brighton – "), _c('i', [_vm._v("Woodstock")]), _vm._v(" succeeds in Edinburgh.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(": vol. ii finished 12 April.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Anne Scott arrives from Cheltenham to help nurse Lady Scott – Scott returns to Edinburgh on the 11th, and lodges at 6 St. David Street – Success of "), _c('i', [_vm._v("Malachi")]), _vm._v(" – The Government measure dropped – Death and funeral of Lady Scott.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Boaden’s "), _c('i', [_vm._v("Life of Kemble")]), _vm._v(" and Kelly’s Reminiscences for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v(" begun on the 27th: Introductory’. "), _c('br'), _vm._v("             Notes on "), _c('i', [_vm._v("The Omen for Blackwood’s Magazine")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Constable’s claim to "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and "), _c('i', [_vm._v("Napoleon")]), _vm._v(" – Hard work on Napoleon – Fear for the future of Scots Law – Short holidays at Abbotsford and Blair-Adam – "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v(" sold to Cadell.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon:")]), _vm._v(" vol. iii finished 12 June; vol. iv begun 14 June. "), _c('i', [_vm._v("Chronicles of the Canongate:")]), _vm._v(" ‘Introductory’ and ‘The Highland Widow’.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Davidoff at Abbotsford for the Selkirk election – End of the quarrel with Lord Melville – To Abbotsford on the 14th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Chronicles of the Canongate:")]), _vm._v(" ‘The Highland Widow’ finished in mid-July. "), _c('i', [_vm._v("Napoleon")]), _vm._v(", vol. iv. Corrections to "), _c('i', [_vm._v("St. Ro- nan’s Well")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("August  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Niece Anne returns to Cheltenham – Walter and Jane arrive from Ireland – A great picnic at Cauldshiels Loch – Short visits to Drumlanrig and Blair-Adam.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon:")]), _vm._v(" vol. iv finished 13 August; vol. v.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("September  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Walter and Charles go to Ireland – Anne takes 3 Walker Street for the winter – Sir John Sinclair proposes a match for Scott – Visits to Jedburgh for the Circuit Court, and to Melville Castle about the Universities Commission.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. v.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("October  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Charles returns to Oxford – Scott goes to London by way of Rokeby – Meets many London friends and passes a day at Windsor – Works on the St. Helena papers at the Colonial Office – Reaches Paris on the 29th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon:")]), _vm._v(" vol v finished early in October.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("In Paris until the 7th – In London early on the 10th – Wellington offers to assist with "), _c('i', [_vm._v("Napoleon")]), _vm._v(" – Scott returns to Abbotsford early on the 26th (by way of Oxford, Cheltenham, Birmingham, and Manchester), and to Edinburgh on the 27th.  \n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott suffers from a cold at the beginning of the month, diarrhoea throughout the month, and rheumatism at its end – To Abbotsford for Christmas – Walter and Jane.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. vi.\n                        ")])])])])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110263-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_xlix"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xlix"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00003"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-184"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1827 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Rheumatism still severe throughout the month – Returns to Edinburgh on the 15th – Walter returns to Ireland – "), _c('i', [_vm._v("Napoleon")]), _vm._v(" to be extended to eight volumes.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vols. vi and vii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Hard work on "), _c('i', [_vm._v("Napoleon")]), _vm._v(" – Rheumatism – Edinburgh dinner-parties – Letter from Goethe – Scott confesses to the authorship of the Waverley Novels at the Theatrical Fund Dinner.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. vii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("To Abbotsford on the 12th – Hard work on "), _c('i', [_vm._v("Napoleon")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. viii. Review of Home’s Works.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Fall of the Ministry – Circuit Court at Jedburgh – Hard work on "), _c('i', [_vm._v("Napoleon")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(": vol. viii finished c. 14 April; vol. ix. Review of "), _c('i', [_vm._v("Home’s Works")]), _vm._v(". Criticism of Defoe for Prose Works.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("To Edinburgh on the 14th – Decides to write "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Hoffmann’s "), _c('i', [_vm._v("Works")]), _vm._v(" for "), _c('i', [_vm._v("Foreign Quarterly Review")]), _vm._v(". "), _c('br'), _vm._v("             Criticism of Defoe. "), _c('i', [_c('br'), _vm._v("             Life of Napoleon")]), _vm._v(", vol. ix.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Oil Gas Coy. affairs – "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" finished – "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(" sold to Cadell – Lockharts at Portobello – Scott at St. Andrews with the Blair-Adam Club.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(": vol. ix finished 7 June. ‘Culloden Papers’, or ‘Essay on Clanship’, "), _c('i', [_vm._v("for Prose Works. Chronicles of the Canongate:")]), _vm._v(" ‘Introduction’ and ‘Two Drovers’. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Tales of a Grandfather.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Four days at Abbotsford before removing there for the vacation on the 11th – Visit to the Edinburgh Academy – Conversation with Lord Melville about politics – Emus offered to the King and the Duke of Buccleuch – Excursions to Yarrow and Minto – Death of Constable – Lord Newton arbitrates in Scott’s favour.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘Culloden Papers’. "), _c('i', [_vm._v("Chronicles of the Canongate:")]), _vm._v(" ‘Two Drovers’ finished 15 July; ‘Surgeon’s Daughter’ begun 27 July. "), _c('i', [_c('br'), _vm._v("             Tales of a Grandfather:")]), _vm._v(" vol. i finished 26 July.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("August  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visit from G. H. Gordon, who helps to arrange Scott’s correspondence – Death of Canning – Possibility of a duel with General Gourgaud – Williams resigns as Rector of Edinburgh Academy – Excursions to Fleurs and Kelso.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Chronicles of the Canongate: ")]), _vm._v("‘Surgeon’s Daughter’. "), _c('br'), _vm._v("             Review of Monteath’s "), _c('i', [_vm._v("The Forester’s Guide")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("September  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("To Glasgow with Lady Compton, by way of Melville Castle and Edinburgh; then to Blythswood, Corehouse, and Lanark.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review continued. "), _c('i', [_vm._v("Chronicles of the Canongate: ")]), _vm._v("‘Surgeon’s Daughter’ finished 16 September. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Tales of a Grandfather:")]), _vm._v(" vol. ii begun 17 September.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("October  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott in Northumberland to see the Duke of Wellington – Letters from Lady Jane Stuart – Arbitration decided mainly in Scott’s favour – Abud threatens the Trust.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Tales of a Grandfather:")]), _vm._v(" vol. iii half finished 16 October, two- thirds finished 20 October.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott returns to Edinburgh on the 4th – The Abud affair – Visits to Lady Jane Stuart – Prize Essay at the University – Plans to buy the copyrights – Union Scottish Assurance Coy. Meeting – A place in the Foreign Office promised to Charles.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘Ornamental Gardening’ begun 7 November, finished 25 November. "), _c('br'), _vm._v("             Last proof of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(" corrected. ‘My Aunt Margaret’s Mirror’ begun.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Lord Newton decrees in Scott’s favour – First dividend of 6s. in the "), _c('i', [_vm._v("£")]), _vm._v(" declared – Further discussions of Abud, and of the copyrights – Cadell and Ballantyne dissatisfied with "), _c('i', [_vm._v("Chronicles of the Canongate;")]), _vm._v(" Scott fears the loss of his reputation – Meetings about the Advocates’ Library, and the Oil Gas Coy. – Huntly Gordon asks for two sermons – Cadell buys the copyrights for "), _c('i', [_vm._v("£")]), _vm._v("8400 – Scott returns by way of Arniston to Abbotsford.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘My Aunt Margaret’s Mirror’ finished 3 December. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("The Fair Maid of Perth")]), _vm._v(" begun 5 December. Additions to "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(".\n                        ")])])])])])])]), _c('p', {
    attrs: {
      "id": "rw-p_110263-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlix"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_l"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_li"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_li"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00004"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-362"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1828")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Birth of Charlotte Lockhart – Scott insists that Cadell employ Ballantyne as printer – Disagreements with Longman over 2nd edition of "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" – To Edinburgh on the 13th – Retirement of Colin Mackenzie – Death of Glengarry – Visit of Mr. Moscheles – Abud’s claim settled – Scott sits to Colvin Smith – Asked by Heath and Reynolds to edit "), _c('i', [_vm._v("The Keepsake")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Molière for Gillies. "), _c('br'), _vm._v("             Revision of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(". Corrections to "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(". "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Fair Maid of Perth:")]), _vm._v(" vol. i two-thirds written on the 21st, nearly finished on the 30th.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visit to Dalkeith – Negotiations on behalf of the Oil Gas Coy. – Feelings of "), _c('i', [_vm._v("déjà-vu")]), _vm._v(" – ‘My Aunt Margaret’s Mirror’ offered to "), _c('i', [_vm._v("The Keepsake")]), _vm._v(" – Discussion on prisons – Ballantyne criticizes "), _c('i', [_vm._v("The Fair Maid of Perth")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Fair Maid of Perth:")]), _vm._v(" vol. i finished 5 February; vol. ii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Fancy Dress Ball – Miss Stirling Grahame’s personifications – Agreement with the Coal Gas Coy. – To Abbotsford on the 13th – The Yeomanry – Cadell’s plans for the Magnum.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Fair Maid of Perth:")]), _vm._v(" vol. iii begun 5 March, finished 29 March. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(" corrected for a 2nd edition.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Journey to London by way of Carlisle, Kenilworth, and Stratford – Terry’s bankruptcy – Quarrel with Lord Minto – Scott rectifies the Road Bill threatening Darnick – Meets Wellington, Croker, Coleridge, Sotheby, Joanna Baillie, Morritt, Knighton, Lord Melville, and other London friends.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘My Aunt Margaret’s Mirror’ revised for "), _c('i', [_vm._v("The Keepsake")]), _vm._v(". "), _c('br'), _vm._v("             Proofs of "), _c('i', [_vm._v("The Fair Maid of Perth")]), _vm._v(" finished.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Dinners at the Literary Society, the Royal Academy, and the Roxburghe Club – The Chancery business – Scott sits to Haydon, Northcote, and Chantry – Breakfasts at Lincoln’s Inn – Dines with the King, and with the Duchess of Kent – Visits the Lockharts in Brighton, and Walter at Hampton Court – Returns by Gill’s Hill and Rokeby. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Reaches Abbotsford on the 2nd, and Edinburgh on the 4th – Williams gives up his London chair – At Blair-Adam from the 27th to the 30th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(", 2nd series.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("9 July–9 January 1829: No Entries. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })])])])])]), _vm._v(" "), _c('br')]), _c('p', {
    attrs: {
      "id": "rw-p_110263-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_li"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_lii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_lii"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00005"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-457"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1829 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott returns to Edinburgh on the 13th – Dr. Knox’s proposed paper on dissections – Thoughts on the anatomists – Visit to Milton- Lockhart and Allanton – Scott meets Green- shields and sits to Graham – Deaths of James Ferrier and Mary Ferguson – Execution of Burke – Cadell about to advertise the Magnum.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Anne of Geierstein")]), _vm._v(", vol. ii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Meeting of the Club – Sale of Stuart of Dunearn’s pictures – Death of Mrs. Ballantyne – Skene assists with "), _c('i', [_vm._v("Anne of")]), _vm._v(" Geierstein – Stories of Waterloo – The Catholic Question.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Anne of Geierstein:")]), _vm._v(" vol. ii. finished 5 February; vol. iii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The booksellers place large orders for the Magnum – Ballantyne condemns "), _c('i', [_vm._v("Anne of Geierstein")]), _vm._v(", which is laid aside while the Catholic Question rages – Restoration of Mons Meg to Edinburgh Castle – Scott returns to Abbotsford on the 11th – Visit from Lord Dalhousie.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Notes for the Magnum and General Preface. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Review of Tytler’s History of Scotland.")]), _vm._v(" "), _c('br'), _vm._v("             Notes on Boswell for Croker. \n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visit from the Skenes – The Hunt meets at Abbotsford – Circuit Court – Death of Lord Buchan – "), _c('i', [_vm._v("Doom of Devorgoil")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Ritson. Article for "), _c('i', [_vm._v("Blackwood’s. Anne of Geierstein")]), _vm._v(", vol. iii. "), _c('i', [_vm._v("Preface to House of As- pen")]), _vm._v(". "), _c('br'), _vm._v(" "), _c('i', [_vm._v("History of Scotland")]), _vm._v(" begun 18 April.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott returns to Edinburgh on the 11th – Dines at Dalhousie Castle – Walter’s illness – Great expectations of the Magnum – The General Assembly of the Church of Scotland – Edward Irving – Farewell dinners to Dalhousie and Hay Drummond – Reflections on the Psalmody.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of "), _c('i', [_vm._v("Le Duc de Guise à Naples")]), _vm._v(". "), _c('i', [_vm._v("History of Scotland")]), _vm._v(". Notes for the Magnum. \n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott alarmed by passing blood – The Theatre given to Mrs. Siddons – Cadell plans to buy the poetry copyrights – Scott sits to Graham – To Abbotsford on the 13th for four days – Sophia, Charles, and the children arrive by steamboat – Meeting of the Blair- Adam Club and visit to Falkland.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("History of Scotland")]), _vm._v(", half-volume finished 1 June. "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(", enlarged 3rd series.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("His children and grandchildren go to Abbotsford, where Scott joins them on the 9th – The Stewart Papers – Death of Shortreed – Mrs. Hemans at Chiefswood.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("T"), _c('i', [_vm._v("ales of a Grandfather. History of Scotland")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("21 July–22 May 1830: No Entries. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_lii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_liii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_liii"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00006"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-571"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1830 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Death of Scott of Raeburn – New line proposed for the road – Scott intends to retire – The Lockharts arrive for the summer.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Demonology")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Edinburgh, Abbotsford, and Blair-Adam – Visit to Culross – Fanny Kemble acts in Edinburgh – Visit to Prestonpans – William IV proclaimed King.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Demonology: ")]), _vm._v("one-third finished 2 June, two-thirds finished 16 June.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Dinners of the Club and the Bannatyne – Miss Doe Sinclair in love with Scott – Return to Abbotsford.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Demonology")]), _vm._v(", seven-eighths finished 5 July.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("19 July–19 December: One Entry only. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Second dividend of 3s. in the "), _c('i', [_vm._v("£")]), _vm._v(" – Scott presented with his library and furniture – Retirement from the Court – Scott’s two strokes – Political agitation – Scott stops a prisoner escaping from the Sheriff Court – Death of Bell Ferguson – New line for the road agreed.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris")]), _vm._v(". Notes to Woodstock. Political article on Income Tax (unfinished). \n                        ")])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_liii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_liv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_liv"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00007"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-643"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1831 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott ‘Decidedly weaker in point of health’ – Prepares to make his will – Discusses politics with Henry Scott – Sits to MacDonald the sculptor – Uses Laidlaw as amanuensis.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Goes to Edinburgh to make his will – Acquires a brace for his lame leg – Delayed by snow.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris")]), _vm._v(", vol. ii. "), _c('br'), _vm._v("             Notes on "), _c('i', [_vm._v("Redgauntlet")]), _vm._v(" and "), _c('i', [_vm._v("Tales of Crusaders.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Reform meetings at Selkirk and Jedburgh – Scott refuses Cadell a half-share in the later copyrights – His typical day at this time – Reform Bill carried in the Commons – Scott sits to Grant.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Review of The British Herald ")]), _vm._v("(never published). "), _c('br'), _vm._v("             Address on the Reform Bill (rejected). "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Count Robert of Paris:")]), _vm._v(" vol. iii begun 16 March.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Manuscripts adjudged to Constable – Foundation stone laid for Tweed bridge – Scott’s third stroke on the 17th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Lockharts arrive for the summer – J. B. and Cadell condemn vol. iii of "), _c('i', [_vm._v("Count Robert")]), _vm._v(" – Election at Jedburgh: ‘Burke Sir Walter’.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris ")]), _vm._v("nearly finished, but laid aside onthe 12th.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("26 May–22 September: No Entries. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("September  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Yarrow visited with Wordsworth – Journey to London.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Notes to the Magnum. "), _c('i', [_vm._v("Reliquiae Trotcosienses")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("October  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("London friends – Reform riots – Stories of magic, and of Garrick – Portsmouth – The "), _c('i', [_vm._v("Barham")]), _vm._v(" sails for Malta on the 29th.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The voyage – Graham’s Island – In quaran- tine at Malta until the 28th – Friends and sightseeing. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott leaves Malta on the 13th, arrives at Naples on the 17th, and lands there on the 25th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Siege of Malta")]), _vm._v(" (never finished). "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Letters of the Seventeenth Century")]), _vm._v(", partly written by Lady Louisa Stuart.\n                        ")])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_liv"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_lv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_lv"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00008"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-763"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1832  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visits to Court, the Opera, and the Library – Death of Johnnie Lockhart – Success of the Magnum, etc.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Excursion to Pompeii.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Excursion to Paestum.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Story of Il Bizarro – Journey to Rome.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_lv"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22740dc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_chapter_03.vue
// module id = 81
// module chunks = 0